// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "content_item".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { contentBatchItemKindValues, contentBatchItemReviewStatusValues, contentItemSourceValues } from '@borradh-workspace/labels';
/** Response atom for the "content_item" table (1:1 with a DB row, on the wire). */
export const contentItemAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    batchId: z.string().nullable(),
    source: z.enum(contentItemSourceValues),
    kind: z.enum(contentBatchItemKindValues),
    proposalImageKind: z.string().nullable(),
    proposalGraphicOptions: z.unknown().nullable(),
    currentAttemptId: z.string().nullable(),
    approvedAttemptId: z.string().nullable(),
    sourceAssetId: z.string().nullable(),
    reviewStatus: z.enum(contentBatchItemReviewStatusValues),
    position: z.number().nullable(),
    regenerationCount: z.number(),
    scheduledSocialPostId: z.string().nullable(),
    scheduledAt: z.string().datetime().nullable(),
    targetPageIds: z.unknown().nullable(),
    videoIdea: z.unknown().nullable(),
    pendingRegenerate: z.unknown().nullable(),
    decidedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=contentItem.js.map